<template>
  <Loading v-show="show" />

  <div id="nav">
    <header>
      <div class="header-top">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-6 d-none d-lg-block d-md-block">
              <p style="margin-bottom: 0rem">
                <span style="margin-left: 10px" id="address_header"></span>
                <span style="margin-left: 10px" id="phone_header"></span>
              </p>
            </div>
            <div class="col-lg-6 col-md-6 col-12">
              <div class="header-top-right">
                <div class="content">
                  <router-link to="/ContactUs" id="welcom_header">
                  </router-link>
                </div>
                <div class="content lang_div_med">
                  <a id="lang_btn" @click="lang('Ar')">العربية</a>
                </div>
                <div class="content lang_div_med">
                  <a id="lang_btn" @click="lang('En')">English</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header-logo-menu sticker">
        <div class="container">
          <div class="row">
            <div class="col-lg-2 col-12">
              <div class="logo">
                <router-link to="/">
                  <img
                    id="logo_image_newTouch"
                    v-bind:src="TopLogoUrl"
                    alt=""
                  />
                </router-link>
              </div>
            </div>
            <div class="col-lg-10 col-12">
              <div class="mainmenu-area pull-left" style="text-align: left">
                <div class="mainmenu d-none d-lg-block">
                  <nav>
                    <ul id="nav">
                      <li class="current">
                        <router-link to="/">{{ home }}</router-link>
                      </li>
                      <li>
                        <a href="javascript:void(0)">{{ aboutUs }} </a>
                        <ul class="sub-menu" style="width: 280px">
                          <li v-for="leader in Leader" :key="leader.postId">
                            <router-link
                              :to="{
                                name: 'Leader-with-id-And-Type',
                                params: {
                                  type: 'Univ.Home.Leader',
                                  id: leader.postID,
                                },
                              }"
                            >
                              {{ leader.postTitle }}<i :class="leader.icon1"></i
                            ></router-link>
                          </li>
                          <li
                            v-for="aboutdata in AboutData"
                            :key="aboutdata.postId"
                          >
                            <router-link
                              :to="{
                                name: 'Page-with-id-And-Type',
                                params: {
                                  type: 'Univ.Home.AboutMenue',
                                  id: aboutdata.postID,
                                },
                              }"
                            >
                              {{ aboutdata.postTitle
                              }}<i :class="aboutdata.icon1"></i
                            ></router-link>
                          </li>
                        </ul>
                      </li>
                      <!-- for management -->
                      <li>
                        <a href="javascript:void(0)">{{ Management }} </a>
                        <ul class="sub-menu" style="width: 280px">
                          <li
                            v-for="managedata in ManagementData"
                            :key="managedata.postId"
                          >
                            <router-link
                              :to="{
                                name: 'Page-with-id-And-Type',
                                params: {
                                  type: 'Univ.Managments',
                                  id: managedata.postID,
                                },
                              }"
                            >
                              {{ managedata.postTitle
                              }}<i :class="managedata.icon1"></i
                            ></router-link>
                          </li>
                        </ul>
                      </li>
                      <!-- end management   -->
                      <!-- Faculty -->
                      <li>
                        <a href="javascript:void(0)">{{ colege }}</a>
                        <ul class="sub-menu" style="width: 288px">
                          <li v-for="faculty in Faculty" :key="faculty.BrnId">
                            <router-link
                              :to="{
                                name: 'Faculties-with-id',
                                params: {
                                  id: faculty.BrnId,
                                },
                              }"
                            >
                              {{ faculty.Faculty }}
                            </router-link>
                          </li>
                        </ul>
                      </li>
                      <!-- Faculty end -->
                      <!-- Research -->
                      <li>
                        <a href="javascript:void(0)">{{
                          ScientificResearch
                        }}</a>
                        <ul class="sub-menu" style="width: 288px">
                          <li
                            v-for="research in Research"
                            :key="research.BrnId"
                          >
                            <router-link
                              :to="{
                                name: 'research-with-id',
                                params: {
                                  id: research.BrnId,
                                },
                              }"
                            >
                              {{ research.Faculty }}
                            </router-link>
                          </li>
                        </ul>
                      </li>
                      <!-- Research end -->
                      <!-- Center -->
                      <li>
                        <a
                          href="javascript:voi
                        d(0)"
                          >{{ cnter }}</a
                        >
                        <ul class="sub-menu" style="width: 288px">
                          <li v-for="Center in Centers" :key="Center.BrnId">
                            <router-link
                              :to="{
                                name: 'Centers-with-id',
                                params: {
                                  id: Center.BrnId,
                                },
                              }"
                            >
                              {{ Center.Faculty }}
                            </router-link>
                          </li>
                        </ul>
                      </li>
                      <!-- Center end -->
                      <!-- service -->
                      <li>
                        <a href="javascript:void(0)">{{ Service }} </a>
                        <ul class="sub-menu" style="width: 288px">
                          <li
                            v-for="service in ServiceData"
                            :key="service.postID"
                          >
                            <router-link
                              :to="{
                                name: 'Service',
                                params: {
                                  id: service.postID,
                                },
                              }"
                            >
                              {{ service.postTitle }}
                            </router-link>
                          </li>
                        </ul>
                      </li>
                      <!-- end service -->

                      <li class="current">
                        <a
                          href="http://sa.yuniv.net/Studentportal/login"
                          target="_blank"
                          >{{ portal }}
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile Menu Area start -->
      <div class="mobile-menu-area" data-v-7ba5bd90="">
        <div class="container clearfix mean-container" data-v-7ba5bd90="">
          <div class="mean-bar">
            <a
              
              class="meanmenu-reveal"
              style="background: ; color: ; right: 0; left: auto"
              ><span></span><span></span><span></span
            ></a>
            <nav class="mean-nav">
              <ul  data-v-7ba5bd90="" style="display: none">
                <li class="current" data-v-7ba5bd90="">
                  <router-link
                    to="/"
                    class="router-link-active router-link-exact-active"
                    data-v-7ba5bd90=""
                    aria-current="page"
                    >{{home}}</router-link
                  >
                </li>
                 <li data-v-7ba5bd90="">
                      <a href="javascript:void(0)" data-v-7ba5bd90="">{{ aboutUs }} </a>
                      <ul class="sub-menu" data-v-7ba5bd90="" style="width: 280px">
                        <li data-v-7ba5bd90="" v-for="leader in Leader" :key="leader.postId">
                          <router-link data-v-7ba5bd90=""
                            :to="{
                              name: 'Leader-with-id-And-Type',
                              params: {
                                type: 'Univ.Home.Leader',
                                id: leader.postID,
                              },
                            }"
                          >
                            {{ leader.postTitle }}<i :class="leader.icon1"></i
                          ></router-link>
                        </li>

                        <li
                          v-for="aboutdata in AboutData"
                          :key="aboutdata.postId" data-v-7ba5bd90=""
                        >
                          <router-link
                            :to="{
                              name: 'Page-with-id-And-Type',
                              params: {
                                type: 'Univ.Home.AboutMenue',
                                id: aboutdata.postID,
                              },
                            }"
                          >
                            {{ aboutdata.postTitle
                            }}<i :class="aboutdata.icon1"></i
                          ></router-link>
                        </li>
                      </ul>
                    </li>
               
                <!-- fore management  -->
              <li>
                      <a href="javascript:void(0)">{{ Management }} </a>
                      <ul data-v-7ba5bd90="" class="sub-menu" style="width: 280px">
                        <li data-v-7ba5bd90=""
                          v-for="managedata in ManagementData"
                          :key="managedata.postId"
                        >
                          <router-link
                            :to="{
                              name: 'Page-with-id-And-Type',
                              params: {
                                type: 'Univ.Managments',
                                id: managedata.postID,
                              },
                            }"
                          >
                            {{ managedata.postTitle
                            }}<i :class="managedata.icon1"></i
                          ></router-link>
                        </li>
                      </ul>
                    </li>
                    <!-- end management -->
                    <li data-v-7ba5bd90="">
                      <a href="javascript:void(0)">{{ colege }}</a>
                      <ul data-v-7ba5bd90="" class="sub-menu">
                        <li data-v-7ba5bd90="" v-for="faculty in Faculty" :key="faculty.BrnId">
                          <router-link
                            :to="{
                              name: 'Faculties-with-id',
                              params: {
                                id: faculty.BrnId,
                              },
                            }"
                          >
                            {{ faculty.Faculty }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                    <li data-v-7ba5bd90="">
                      <a data-v-7ba5bd90="" href="javascript:void(0)">{{ScientificResearch}}</a>
                      <ul data-v-7ba5bd90="" class="sub-menu" style="width: 288px">
                        <li data-v-7ba5bd90="" v-for="research in Research" :key="research.BrnId">
                          <router-link
                            :to="{
                              name: 'research-with-id',
                              params: {
                                id: research.BrnId,
                              },
                            }"
                          >
                            {{ research.Faculty }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                      <!-- Center -->
                      <li data-v-7ba5bd90="">
                        <a data-v-7ba5bd90="" href="javascript:voi
                        d(0)">{{ cnter }}</a>
                        <ul data-v-7ba5bd90="" class="sub-menu" style="width: 288px">
                          <li data-v-7ba5bd90="" v-for="Center in Centers" :key="Center.BrnId">
                            <router-link
                              :to="{
                                name: 'Centers-with-id',
                                params: {
                                  id: Center.BrnId,
                                },
                              }"
                            >
                              {{ Center.Faculty }}
                            </router-link>
                          </li>
                        </ul>
                      </li>
                      <!-- Center end -->
                  
                    <!-- service -->
                    <li data-v-7ba5bd90="">
                      <a data-v-7ba5bd90="" href="javascript:void(0)">{{ Service }} </a>
                      <ul data-v-7ba5bd90="" class="sub-menu" style="width: 288px">
                        <li data-v-7ba5bd90=""
                          v-for="service in ServiceData"
                          :key="service.postID"
                        >
                          <router-link
                            :to="{
                              name: 'Service',
                              params: {
                                id: service.postID,
                              },
                            }"
                          >
                            {{ service.postTitle }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                    <!-- end service -->
                    
                    <li data-v-7ba5bd90="">
                      <router-link to="/ContactUs"> {{ contact2 }}</router-link>
                     
                    </li>

                    <li>
                      <a > {{ language }}</a>
                      <ul class="sub-menu">
                        <a @click="lang('Ar')">
                          <li >العربية</li></a
                        >
                        <a @click="lang('En')">
                          <li >English</li></a
                        >
                      </ul>
                    </li>

              </ul>
            </nav>
          </div>
          <div class="row" data-v-7ba5bd90="">
            <div class="col-lg-12 col-md-12 col-sm-12" data-v-7ba5bd90="">
              <div class="mobile-menu" data-v-7ba5bd90="">
                <div class="mean-push"></div>
                <nav id="dropdown" data-v-7ba5bd90="" style="display: none">
                  <ul dir="rtl" data-v-7ba5bd90="">
                    <li data-v-7ba5bd90="" class="current">
                      <router-link to="/">{{ home }}</router-link>
                    </li>
                   <li>
                      <a href="javascript:void(0)" data-v-7ba5bd90="">{{ aboutUs }} </a>
                      <ul data-v-7ba5bd90="" class="sub-menu" style="width: 280px">
                        <li data-v-7ba5bd90="" v-for="leader in Leader" :key="leader.postId">
                          <router-link
                            :to="{
                              name: 'Leader-with-id-And-Type',
                              params: {
                                type: 'Univ.Home.Leader',
                                id: leader.postID,
                              },
                            }"
                          >
                            {{ leader.postTitle }}<i :class="leader.icon1"></i
                          ></router-link>
                        </li>

                        <li data-v-7ba5bd90=""
                          v-for="aboutdata in AboutData"
                          :key="aboutdata.postId"
                        >
                          <router-link
                            :to="{
                              name: 'Page-with-id-And-Type',
                              params: {
                                type: 'Univ.Home.AboutMenue',
                                id: aboutdata.postID,
                              },
                            }"
                          >
                            {{ aboutdata.postTitle
                            }}<i :class="aboutdata.icon1"></i
                          ></router-link>
                        </li>
                      </ul>
                    </li>
                    <!-- fore management  -->

                  <li data-v-7ba5bd90="">
                      <a data-v-7ba5bd90="" href="javascript:void(0)">{{ Management }} </a>
                      <ul data-v-7ba5bd90="" class="sub-menu" style="width: 280px">
                        <li data-v-7ba5bd90=""
                          v-for="managedata in ManagementData"
                          :key="managedata.postId"
                        >
                          <router-link
                            :to="{
                              name: 'Page-with-id-And-Type',
                              params: {
                                type: 'Univ.Managments',
                                id: managedata.postID,
                              },
                            }"
                          >
                            {{ managedata.postTitle
                            }}<i :class="managedata.icon1"></i
                          ></router-link>
                        </li>
                      </ul>
                    </li>
                    <!-- end management -->
                    <li data-v-7ba5bd90="">
                      <a data-v-7ba5bd90="" href="javascript:void(0)">{{ colege }}</a>
                      <ul data-v-7ba5bd90="" class="sub-menu">
                        <li data-v-7ba5bd90="" v-for="faculty in Faculty" :key="faculty.BrnId">
                          <router-link
                            :to="{
                              name: 'Faculties-with-id',
                              params: {
                                id: faculty.BrnId,
                              },
                            }"
                          >
                            {{ faculty.Faculty }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                    <li data-v-7ba5bd90="">
                      <a data-v-7ba5bd90="" href="javascript:void(0)">{{ScientificResearch}}</a>
                      <ul data-v-7ba5bd90="" class="sub-menu" style="width: 288px">
                        <li data-v-7ba5bd90="" v-for="research in Research" :key="research.BrnId">
                          <router-link
                            :to="{
                              name: 'research-with-id',
                              params: {
                                id: research.BrnId,
                              },
                            }"
                          >
                            {{ research.Faculty }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                      <!-- Center -->
                      <li data-v-7ba5bd90="">
                        <a data-v-7ba5bd90="" href="javascript:void(0)">{{ cnter }}</a>
                        <ul data-v-7ba5bd90="" class="sub-menu" style="width: 288px">
                          <li data-v-7ba5bd90="" v-for="Center in Centers" :key="Center.BrnId">
                            <router-link
                              :to="{
                                name: 'Centers-with-id',
                                params: {
                                  id: Center.BrnId,
                                },
                              }"
                            >
                              {{ Center.Faculty }}
                            </router-link>
                          </li>
                        </ul>
                      </li>
                      <!-- Center end -->
                    
                    <li data-v-7ba5bd90="">
                      <a data-v-7ba5bd90="" href="javascript:void(0)">{{ Service }} </a>
                      <ul data-v-7ba5bd90="" class="sub-menu" style="width: 288px">
                        <li data-v-7ba5bd90=""
                          v-for="service in ServiceData"
                          :key="service.postID"
                        >
                          <router-link
                            :to="{
                              name: 'Service',
                              params: {
                                id: service.postID,
                              },
                            }"
                          >
                            {{ service.postTitle }}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                   

                    <li >
                      <router-link to="/ContactUs"> {{ contact2 }}</router-link>
                   
                    </li>

                    <li>
                      <a> {{ language }}</a>
                      <ul class="sub-menu">
                        <a @click="lang('Ar')">
                          <li  >العربية</li></a
                        >
                        <a @click="lang('En')">
                          <li  >English</li></a
                        >
                      </ul>
                    </li>

                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Mobile Menu Area End -->
    </header>

    <router-view :key="$route.fullPath"></router-view>

    <div
      class="newsletter-area newsletter-area_3"
      style="
        border-radius: 0 !important;
        background: rgba(0, 0, 0, 0) url(img/banner/2.jpg) repeat scroll 100% 0;
      "
    >
      <div class="container">
        <div class="row rowFooter">
          <div class="col-lg-5 col-md-5">
            <div class="newsletter-content">
              <h3 id="postTitleFooter"></h3>
              <h2 id="postSubTitleFooter"></h2>
            </div>
          </div>
          <div class="col-lg-7 col-md-7">
            <div class="newsletter-form angle d-none">
              <form
                action="#"
                id="mc-form"
                class="mc-form footer-newsletter fix"
              >
                <div class="subscribe-form">
                  <input
                    id="mc-email "
                    type="email "
                    name="email "
                    placeholder="ادخل البريد الالكترونى"
                  />
                  <button id="mc-submit " type="submit">الإشتراك</button>
                </div>
              </form>
              <div class="mailchimp-alerts text-centre fix pull-left">
                <div class="mailchimp-submitting"></div>
                <div class="mailchimp-success"></div>
                <div class="mailchimp-error"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="footer-widget-area"
      style="
        background: rgba(0, 0, 0, 0)
          url(data:image/jpeg;base64,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)
          repeat scroll 100% 0;
      "
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <div class="single-footer-widget">
              <div class="footer-logo">
                <router-link to="/">
                  <img v-bind:src="bottomLogoUrl" alt=" "
                /></router-link>
              </div>
              <p id="postDetails"></p>
              <div class="social-icons">
                <a id="facebook_footer" target="_blank"
                  ><img src="/img/facebook.svg" alt="" />
                </a>
                <a id="instgram_footer" target="_blank"
                  ><img src="/img/instagram.svg" alt=""
                /></a>
                <a id="twitter_footer" target="_blank"
                  ><img src="/img/twitter.svg" alt=""
                /></a>
                <a id="youtube_footer" target="_blank"
                  ><img src="/img/youtube.svg" alt=""
                /></a>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="single-footer-widget">
              <h3>{{ contct }}</h3>
              <!-- <a id="f11_footer" href="tel:0123-456-789 "></a> -->
              <a href="tel:0123-456-789 " id="f21_footer"></a>
              <a href="tel:0123-456-789 " id="f31_footer"></a>
              <span id="f41_footer"></span>
              <span id="f51_footer"></span>
              <span id="f61_footer"></span>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="single-footer-widget">
              <h3>{{ browseMore }}</h3>
              <ul class="footer-list">
                <li>
                  <router-link to="/">{{ home }}</router-link>
                </li>

                <li v-for="leader in Leader" :key="leader.postId">
                  <router-link
                    :to="{
                      name: 'Leader-with-id-And-Type',
                      params: {
                        type: 'Univ.Home.Leader',
                        id: leader.postID,
                      },
                    }"
                  >
                    {{ leader.postTitle }}</router-link
                  >
                </li>

                <li v-for="aboutdata in AboutData" :key="aboutdata.postId">
                  <router-link
                    :to="{
                      name: 'Page-with-id-And-Type',
                      params: {
                        type: 'Univ.Home.AboutMenue',
                        id: aboutdata.postID,
                      },
                    }"
                  >
                    {{ aboutdata.postTitle }}</router-link
                  >
                </li>

                <li>
                  <router-link to="/ContactUs">{{ contact2 }} </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="single-footer-widget">
              <h3>{{ colege }}</h3>
              <ul class="footer-list">
                <li v-for="faculty in Faculty" :key="faculty.BrnId">
                  <router-link
                    :to="{
                      name: 'Faculties-with-id',
                      params: {
                        id: faculty.BrnId,
                      },
                    }"
                  >
                    {{ faculty.Faculty }}
                  </router-link>
                </li>

                <li>
                  <router-link to="/ContactUs">{{ contact2 }} </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer-area" style="border-radius: 0 !important">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-7 col-12">
            <span>{{ copyRight }}</span>
          </div>
          <div class="col-lg-6 col-md-5 col-12">
            <div class="column-right">
              <span
                >Powered by<a
                  class="link_newtouch"
                  href="http://newtouch.dev/"
                  target="_blank"
                >
                  NewTouch</a
                >
                Smart Technology Solutions
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Loading from "./components/Loading";
import axios from "axios";
import ArJson from "../public/i18n/Ar.json";
import EnJson from "../public/i18n/En.json";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      show: true,
      TopLogoUrl: "",
      bottomLogoUrl: "",
      ScientificResearch: "",
      FooterData: [],
      AboutData: [],
      Leader: [],
      CenterData: [],
      Gellery: [],
      Faculty: [],
      Centers: [],
      Research: [],
      ArTranslat: ArJson,
      EnTranslat: EnJson,
      translate: "",
      home: "",
      aboutUs: "",
      cnter: "",
      colege: "",
      portal: "",
      contct: "",
      language: "",
      browseMore: "",
      copyRight: "",

      Management: "",
      Service: "",
      contact2: "",
      ServiceData: [],
      ManagementData: [],
    };
  },
  mounted() {
    var self = this;
    if (localStorage.getItem("lang") == null) {
      axios({
        method: "get",
        url: "https://api2.yuniv.net:444/languages/getLangIsMain",
      })
        .then(function (response) {
          localStorage.setItem("lang", response.data[0]["LangId"]);
          if (response.data[0]["LangId"] == "Ar") {
            self.translate = self.ArTranslat;
            document.getElementById("langfilewebsites")?.remove();
            self.getApis();
          } else {
            self.translate = self.EnTranslat;
            let link1 = document.createElement("link");
            link1.setAttribute("rel", "stylesheet");
            link1.id = "langfilewebsites";
            link1.setAttribute("href", "./style-ltr.css");
            document.head.appendChild(link1);
            self.getApis();
          }
        })
        .catch(function (response) {
          console.log("error", response);
        });
    } else {
      //translate
      if (localStorage.getItem("lang") == "Ar") {
        self.translate = self.ArTranslat;
        document.getElementById("langfilewebsites")?.remove();
        self.getApis();
      } else {
        self.translate = self.EnTranslat;
        let link1 = document.createElement("link");
        link1.setAttribute("rel", "stylesheet");
        link1.id = "langfilewebsites";
        link1.setAttribute("href", "./style-ltr.css");
        document.head.appendChild(link1);
        self.getApis();
      }
    }
  },
  methods: {
    lang(lang) {
      localStorage.setItem("lang", lang);
      location.reload();
    },
    getApis() {
      var self = this;
      var bodyFormData2 = new FormData();
      self.home = self.translate[0]["HeaderAndFooter"]["Home"];
      self.aboutUs = self.translate[0]["HeaderAndFooter"]["about"];
      self.colege = self.translate[0]["HeaderAndFooter"]["college"];
      self.cnter = self.translate[0]["HeaderAndFooter"]["centers"];
      self.portal = self.translate[0]["HeaderAndFooter"]["studentPortal"];
      self.contct = self.translate[0]["HeaderAndFooter"]["contact"];
      self.language = self.translate[0]["HeaderAndFooter"]["Languages"];
      self.browseMore = self.translate[0]["HeaderAndFooter"]["browseMore"];
      self.copyRight = self.translate[0]["HeaderAndFooter"]["copyRight"];
      self.contact2 = self.translate[0]["HeaderAndFooter"]["contact2"];
      self.Service = self.translate[0]["HeaderAndFooter"]["Service"];
      self.Management = self.translate[0]["HeaderAndFooter"]["Management"];
      self.ScientificResearch =
        self.translate[0]["HeaderAndFooter"]["ScientificResearch"];

      // self.library = self.ArTranslat[0]["HeaderAndFooter"]["library"];

      bodyFormData2.append("check", "getPost");
      bodyFormData2.append("Lang", localStorage.getItem("lang"));
      bodyFormData2.append("FbrnId", "");
      bodyFormData2.append("Type", "Univ.Header.Data");
      bodyFormData2.append("ParentId", "NTROOT0");
      bodyFormData2.append("PostName", "");
      bodyFormData2.append("Pno", "1");
      axios({
        method: "post",
        url: "https://api2.yuniv.net:444/our_team/getPost",
        data: bodyFormData2,
      })
        .then(function (response) {
          var arr = response.data;
          if (arr.length != 0) {
            self.TopLogoUrl =
              "https://api2.yuniv.net:444/images/post/" +
              response.data[0]["postImage"];
            document.getElementById("welcom_header").innerHTML =
              '<i class="fa fa-graduation-cap"style="padding-left: 7px; font-size: 16px"></i>' +
              response.data[0]["f1"];
            document.getElementById("address_header").innerHTML =
              '<i class="fa  fa-map-marker"></i>' + response.data[0]["f2"];
            document.getElementById("phone_header").innerHTML =
              '<i class="fa fa-phone"></i>' + response.data[0]["f3"];
          }
          var bodyFormData = new FormData();
          bodyFormData.append("check", "getPostDetails");
          bodyFormData.append("Lang", localStorage.getItem("lang"));
          bodyFormData.append("FbrnId", "");
          bodyFormData.append("Type", "Univ.Footer.Data");
          bodyFormData.append("ParentId", "NTROOT0");
          bodyFormData.append("PostName", "");
          bodyFormData.append("Pno", "1");
          axios({
            method: "post",
            url: "https://api2.yuniv.net:444/our_team/getPost",
            data: bodyFormData,
          })
            .then(function (response) {
              self.FooterData = response.data;
              if (self.FooterData.length != 0) {
                self.bottomLogoUrl =
                  "https://api2.yuniv.net:444/images/post/" +
                  self.FooterData[0]["postImage"];

                document
                  .getElementById("facebook_footer")
                  .setAttribute("href", response.data[0]["facebook1"]);

                document
                  .getElementById("facebook_footer")
                  .setAttribute("href", response.data[0]["facebook1"]);
                document
                  .getElementById("instgram_footer")
                  .setAttribute("href", response.data[0]["instgram1"]);
                document
                  .getElementById("twitter_footer")
                  .setAttribute("href", response.data[0]["tweeter1"]);
                document
                  .getElementById("youtube_footer")
                  .setAttribute("href", response.data[0]["youtube1"]);

                document.getElementById("postTitleFooter").innerText =
                  response.data[0]["postTitle"];
                document.getElementById("postSubTitleFooter").innerText =
                  response.data[0]["postSubTitle"];
                // document.getElementById("f11_footer").innerHTML =
                //   '<i class="fa fa-phone"></i>' + response.data[0]["f11"];
                document.getElementById("f21_footer").innerHTML =
                  '<i class="fa fa-phone"></i>' + response.data[0]["f21"];
                document.getElementById("f31_footer").innerHTML =
                  '<i class="fa fa-phone"></i>' + response.data[0]["f31"];
                document.getElementById("f41_footer").innerHTML =
                  '<i class="fa fa-envelope"></i>' + response.data[0]["f41"];
                document.getElementById("f51_footer").innerHTML =
                  '<i class="fa fa-globe"></i>' + response.data[0]["f51"];
                document.getElementById("f61_footer").innerHTML =
                  '<i class="fa fa-map-marker"></i>' + response.data[0]["f61"];

                document.getElementById("postDetails").innerHTML =
                  self.FooterData[0]["postDetails"];
              }
              var bodyFormData = new FormData();
              bodyFormData.append("check", "getPost");
              bodyFormData.append("Lang", localStorage.getItem("lang"));
              bodyFormData.append("FbrnId", "");
              bodyFormData.append("Type", "Univ.Home.AboutMenue");
              bodyFormData.append("ParentId", "NTROOT0");
              bodyFormData.append("PostName", "");
              bodyFormData.append("Pno", "5");
              axios({
                method: "post",
                url: "https://api2.yuniv.net:444/our_team/getPost",
                data: bodyFormData,
              })
                .then(function (response) {
                  self.AboutData = response.data;

                  var bodyFormData = new FormData();
                  bodyFormData.append("check", "getPost");
                  bodyFormData.append("Lang", localStorage.getItem("lang"));
                  bodyFormData.append("FbrnId", "");
                  bodyFormData.append("Type", "Univ.Home.Leader");
                  bodyFormData.append("ParentId", "NTROOT0");
                  bodyFormData.append("PostName", "");
                  bodyFormData.append("Pno", "6");
                  axios({
                    method: "post",
                    url: "https://api2.yuniv.net:444/our_team/getPost",
                    data: bodyFormData,
                  })
                    .then(function (response) {
                      self.Leader = response.data;

                      // var bodyFormData = new FormData();
                      // bodyFormData.append("check", "getPost");
                      // bodyFormData.append("Lang", localStorage.getItem("lang"));
                      // bodyFormData.append("FbrnId", "");
                      // bodyFormData.append("Type", "Univ.Q.Center");
                      // bodyFormData.append("ParentId", "NTROOT0");
                      // bodyFormData.append("PostName", "");
                      // bodyFormData.append("Pno", "10");
                      // axios({
                      //   method: "post",
                      //   url: "https://api2.yuniv.net:444/our_team/getPost",
                      //   data: bodyFormData,
                      // })
                      //   .then(function (response) {
                      //     self.CenterData = response.data;
                      //     // service
                      var bodyFormData = new FormData();
                      bodyFormData.append("check", "getPost");
                      bodyFormData.append("Lang", localStorage.getItem("lang"));
                      bodyFormData.append("FbrnId", "");
                      bodyFormData.append("Type", "Univ.Services");
                      bodyFormData.append("ParentId", "NTROOT0");
                      bodyFormData.append("PostName", "");
                      bodyFormData.append("Pno", "10");
                      axios({
                        method: "post",
                        url: "https://api2.yuniv.net:444/our_team/getPost",
                        data: bodyFormData,
                      })
                        .then(function (response) {
                          self.ServiceData = response.data;
                          //end service

                          // management
                          var bodyFormData = new FormData();
                          bodyFormData.append("check", "getPost");
                          bodyFormData.append(
                            "Lang",
                            localStorage.getItem("lang")
                          );
                          bodyFormData.append("FbrnId", "");
                          bodyFormData.append("Type", "Univ.Managments");
                          bodyFormData.append("ParentId", "NTROOT0");
                          bodyFormData.append("PostName", "");
                          bodyFormData.append("Pno", "10");
                          axios({
                            method: "post",
                            url: "https://api2.yuniv.net:444/our_team/getPost",
                            data: bodyFormData,
                          })
                            .then(function (response) {
                              self.ManagementData = response.data;
                              //end management

                              // var bodyFormData = new FormData();
                              //       bodyFormData.append("check", "getPost");
                              //       bodyFormData.append(
                              //         "Lang",
                              //         localStorage.getItem("lang")
                              //       );
                              //       bodyFormData.append("FbrnId", "");
                              //       bodyFormData.append("Type", "Univ.Gellery");
                              //       bodyFormData.append("ParentId", "NTROOT0");
                              //       bodyFormData.append("PostName", "");
                              //       bodyFormData.append("Pno", "6");
                              //       axios({
                              //         method: "post",
                              //         url:
                              //           "https://api2.yuniv.net:444/our_team/getPost",
                              //         data: bodyFormData,
                              //       })
                              //         .then(function (response) {
                              //           self.Gellery = response.data;

                              bodyFormData = new FormData();
                              bodyFormData.append("check", "");
                              bodyFormData.append(
                                "Lang",
                                localStorage.getItem("lang")
                              );
                              bodyFormData.append("FbrnId", "U");
                              axios({
                                method: "post",
                                url:
                                  "https://api2.yuniv.net:444/our_team/getMainSys",
                                data: bodyFormData,
                              })
                                .then(function (response) {
                                  response.data.mainBrn.forEach((element) => {
                                    if (element.brnSys == "Univ.Faculty")
                                      self.Faculty.push({
                                        BrnId: element.brnId,
                                        Faculty: element.brnName,
                                      });
                                  });
                                  bodyFormData = new FormData();
                                  bodyFormData.append("check", "");
                                  bodyFormData.append(
                                    "Lang",
                                    localStorage.getItem("lang")
                                  );
                                  bodyFormData.append("FbrnId", "U");
                                  axios({
                                    method: "post",
                                    url:
                                      "https://api2.yuniv.net:444/our_team/getMainSys",
                                    data: bodyFormData,
                                  })
                                    .then(function (response) {
                                      response.data.mainBrn.forEach(
                                        (element) => {
                                          if (element.brnSys == "Univ.Research")
                                            self.Research.push({
                                              BrnId: element.brnId,
                                              Faculty: element.brnName,
                                            });
                                        }
                                      );

                                      //  center
                                      bodyFormData.append("FbrnId", "U");
                                      axios({
                                        method: "post",
                                        url:
                                          "https://api2.yuniv.net:444/our_team/getMainSys",
                                        data: bodyFormData,
                                      })
                                        .then(function (response) {
                                          response.data.mainBrn.forEach(
                                            (element) => {
                                              if (
                                                element.brnSys == "Univ.Centers"
                                              )
                                                self.Centers.push({
                                                  BrnId: element.brnId,
                                                  Faculty: element.brnName,
                                                });
                                            }
                                          );
                                         
                                          setTimeout(() => {
                                            self.show = false;
                                          }, 100);
                                        })
                                        .catch(function (response) {
                                          console.log("error", response);
                                        });
                                    })
                                    .catch(function (response) {
                                      console.log("error", response);
                                    });
                                })
                                .catch(function (response) {
                                  console.log("error", response);
                                });
                            })
                            .catch(function (response) {
                              console.log("error", response);
                            });
                        })
                        .catch(function (response) {
                          console.log("error", response);
                        });
                    })
                    .catch(function (response) {
                      console.log("error", response);
                    });
                })
                .catch(function (response) {
                  console.log("error", response);
                });
            })
            .catch(function (response) {
              console.log("error", response);
            });
        })
        .catch(function (response) {
          console.log("error", response);
        });
      // })
      // .catch(function (response) {
      //   console.log("error", response);
      // });
      //   })
      // .catch(function (response) {
      //   console.log("error", response);
      // });
    },
  },
};
</script>

<style scoped>
.lang_btn {
  cursor: pointer !important;
}
.font_color {
  color: #0c3ef7;
}
.link_newtouch {
  color: #0c3ef7;
  font-weight: bold;
}
li i {
  color: #0c3ef7;
}
li a {
  font-weight: bold;
}
.footer-img {
  width: 80px;
  height: 80px;
}
.mean-container .mean-nav ul li a {
  background: #f8f8f8;
  color: #666;
  display: block;
  float: left;
  font-size: 12px;
  margin: 0;
  padding: 1em 5%;
  text-align: right;
  text-decoration: none;
  text-transform: uppercase;
  width: 90%;
  font-weight: 700;
}
.mean-container .mean-nav ul li a.mean-expand {
  width: 26px;
  height: 15px;
  margin-top: 1px;
  padding: 12px !important;
  text-align: center;
  position: absolute;
  left: 0 !important;
  top: 0;
  z-index: 2;
  font-weight: 700;
  border: 0 !important;
  background: #f8f8f8;
}
#postTitleFooter,
#postSubTitleFooter {
  color: #000;
}
#logo_image_newTouch {
  margin-top: -6px;
  max-width: 133% !important;
}
a {
  cursor: pointer;
}
</style>
